/**
 *  Если написать что-то не на ANSII (EN), то  автоматически будет выбрана кодировка UTF-8
 *  Это происходит автоматически. Больше ничего делать не нужно.
 */

import Tabs from './tabs_class.js'

document.addEventListener('DOMContentLoaded', () => {
	new Tabs();
});
